// TODO(CHANGE-68174): This folder is dead code if we're not supporting sharing bandits.
import type { JSX, PropsWithChildren } from 'react';
import { useMemo } from 'react';

import { ShareHeadlineContext } from './context';
import type { ShareHeadline } from './types';

type Props = ShareHeadline;

export function ShareHeadlineProvider({
	children,
	description,
	title,
	sharer,
	previewLink,
}: PropsWithChildren<Props>): JSX.Element {
	const text = useMemo(
		() => ({
			description,
			title,
			sharer,
			previewLink,
		}),
		[description, title, sharer, previewLink],
	);

	return <ShareHeadlineContext.Provider value={text}>{children}</ShareHeadlineContext.Provider>;
}
